import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetDetailedGeneralLedgerQuery } from "../../../services/Reports";
import {
  getDetailedGeneralLedgerRequest,
  getDetailedGeneralLedgerFailure,
  getDetailedGeneralLedgerSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  const accountState = useAppSelector((state) => state.accountCharts);
  // State
  const state = useAppSelector((state) => state.reports);
  const chartIds = useAppSelector(
    (state) => state.accountCharts.accountChartsIds,
  );
  const firstChartId = chartIds.length > 0 ? chartIds[0].accountId : "";
  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allDetailedGeneralLedger,
    isLoading: detailedGeneralLedgerLoading,
    isError: detailedGeneralLedgerError,
  } = useGetDetailedGeneralLedgerQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.detailedGeneralLedgerPageNo,
    pageSize: state.detailedGeneralLedgerPageSize,
    fromDate: new Date(
      state.detailedGeneralLedgerFromDate,
    ).toLocaleDateString(),
    toDate: new Date(state.detailedGeneralLedgerToDate).toLocaleDateString(),
    accountId: accountState.accountId ? accountState.accountId : firstChartId,
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (detailedGeneralLedgerLoading) {
      dispatch(getDetailedGeneralLedgerRequest());
    }
    if (detailedGeneralLedgerError) {
      dispatch(getDetailedGeneralLedgerFailure(detailedGeneralLedgerError));
    }
    if (allDetailedGeneralLedger) {
      dispatch(
        getDetailedGeneralLedgerSuccess({
          data:
            allDetailedGeneralLedger.data.detailedGeneralLedger[0].data || [],
          totalPages:
            allDetailedGeneralLedger.data.detailedGeneralLedger[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allDetailedGeneralLedger,
    profileData,
    state.detailedGeneralLedgerFromDate,
    state.detailedGeneralLedgerToDate,
    state.detailedGeneralLedgerPageNo,
    state.detailedGeneralLedgerPageSize,
  ]);
  return <></>;
};
export default Content;
